import { Box, Center, Flex, Group, Table as MantineTable } from '@mantine/core';
import { useElementSize } from '@mantine/hooks';
import { forwardRef, useRef, useState } from 'react';
import { TableSlider } from './table-slider';
import './table.overrides.css';
export const GoodTable = forwardRef(({ empty, minWidth = 400, toolbar, footer, floatingScrollbar, ...props }, ref) => {
    const [scrollPosition, setScrollPosition] = useState({
        x: 0,
        y: 0,
    });
    const { width: scrollWidth, ref: tableRef } = useElementSize();
    const { width: outerWidth, ref: outerRef } = useElementSize();
    const { height: footerHeight, ref: footerRef } = useElementSize();
    const scrollRef = useRef(null);
    const overflowX = Math.max(scrollWidth - outerWidth, 0);
    const percentage = overflowX === 0 ? 0 : scrollPosition.x / overflowX;
    return (<Flex h='100%' w='100%' style={{
            overflow: 'hidden',
        }} flex={1} maw={props.maw} pos='relative' direction='column' ref={ref} bg={!empty ? 'var(--mantine-color-body)' : undefined} className='goodTable' data-floating-scrollbar={floatingScrollbar ? 'true' : undefined}>
        {empty && (<Center w='100%' h='100%'>
            {empty}
          </Center>)}
        {!empty && (<>
            {toolbar && (<Box p='sm'>
                <Group justify='space-between' align='center' wrap='nowrap'>
                  {toolbar({
                    slider: (<TableSlider value={percentage} onChange={(value) => {
                            const position = value * overflowX;
                            // biome-ignore lint/style/noNonNullAssertion: we know it's there
                            scrollRef.current.scrollTo({
                                left: position,
                            });
                        }}/>),
                })}
                </Group>
              </Box>)}
            <MantineTable.ScrollContainer minWidth={minWidth} w='100%' h='100%' pos='relative' type='scrollarea' ref={outerRef} scrollAreaProps={{
                onScrollPositionChange: (position) => {
                    setScrollPosition(position);
                },
                viewportRef: scrollRef,
            }}>
              <Box pos='relative' w='100%' h='100%' pb={0}>
                <MantineTable horizontalSpacing='sm' verticalSpacing='sm' ref={tableRef} data-scroll-y={scrollPosition.y > 0 ? 'true' : undefined} data-scroll-x={scrollPosition.x > 0 ? 'true' : undefined} {...props} bg='var(--mantine-color-body)'/>
              </Box>
            </MantineTable.ScrollContainer>
          </>)}
        {footer && (<Box bg='var(--mantine-color-body)' pos='sticky' style={{
                zIndex: 11,
                transition: 'height 0.2s ease-in-out',
                borderTop: footerHeight > 4 ? '1px solid var(--mantine-color-default-border)' : undefined,
            }} bottom={0} w='100%' ref={footerRef}>
            {footer}
          </Box>)}
      </Flex>);
});
